import {PublicClientApplication} from '@azure/msal-browser'
import {ApplicationInsights} from '@microsoft/applicationinsights-web'
import {featureEnabled} from '@/helpers/features'


export default defineNuxtPlugin((nuxtApp) => {
    const appInsightsEnabled = featureEnabled(nuxtApp.$config.public.FEATURE_APPLICATION_INSIGHTS)
    const appInsights = new ApplicationInsights({
        config: {
            connectionString: nuxtApp.$config.public.APPLICATION_INSIGHTS_CONNECTION_STRING,
            loggingLevelConsole: 2,
            loggingLevelTelemetry: 2,
            correlationHeaderDomains: ['*.glommen-mjosen.no'],
            enableCorsCorrelation: true,
            disableAjaxTracking: false,
            disableCorrelationHeaders: false,
            disableFetchTracking: false,
            maxAjaxCallsPerView: -1,
        }
    })

    appInsights.addTelemetryInitializer(envelope => {
        const $msal = nuxtApp.$msal as PublicClientApplication

        try {
            if (envelope?.data) {
                const user = JSON.parse(localStorage.getItem('user') || '{}')
                const userId = user?.Id
                if (userId) {
                    envelope.data.userId = removeQuotes(userId)
                }
                if ($msal) {
                    $msal.initialize()
                    const activeAccount = $msal.getActiveAccount()

                    if (activeAccount) {
                        envelope.data.mail = activeAccount.username
                    }
                }
            }
        }
        catch {}

        return appInsightsEnabled

        function removeQuotes(userId: string): any {
            return userId.substring(1, userId.length - 1)
        }
    })

    appInsights.loadAppInsights();

    const router = useRouter()
    router.afterEach(() => {
        appInsights.trackPageView({
            properties: {
                screenSize: `${window.screen.width}x${window.screen.height}`,
                windowSize: `${window.innerWidth}x${window.innerHeight}`,
            }
        })
    })

    return {
        provide: {
            appInsights
        }
    }
})